import React from 'react';
import { Section } from './Shared';
import { XCircle, AlertCircle, ArrowDown, CheckCircle2 } from 'lucide-react';
export const Problem = () => {
  return <>
      <Section className="bg-gray-50" data-id="element-317">
        <div className="max-w-3xl mx-auto text-center" data-id="element-318">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight mb-12" data-id="element-319">
            Sabés que querés crear contenido…{' '}
            <span className="text-coral" data-id="element-320">pero no lo estás logrando</span>
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-md mb-8" data-id="element-321">
            <div className="flex flex-col items-center gap-4 mb-8" data-id="element-322">
              <span className="text-xl font-semibold text-gray-600" data-id="element-323">
                Abrís Instagram todos los días
              </span>
              <ArrowDown className="text-gray-300" data-id="element-324" />
              <span className="text-xl font-semibold text-gray-600" data-id="element-325">
                Guardás ideas
              </span>
              <ArrowDown className="text-gray-300" data-id="element-326" />
              <span className="text-xl font-semibold text-gray-600" data-id="element-327">
                Te inspirás
              </span>
            </div>

            <div className="border-t border-gray-200 pt-8 mt-4" data-id="element-328">
              <h3 className="font-montserrat font-bold text-2xl mb-6 text-black" data-id="element-329">
                Pero cuando te toca a vos…
              </h3>
              <ul className="space-y-4 text-left max-w-md mx-auto" data-id="element-330">
                {['No sabés qué publicar', 'Dudás de todo', 'Postergás', 'Y terminás sin subir nada'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-lg font-medium text-gray-700" data-id="element-331">
                    <XCircle className="w-6 h-6 text-red-500 shrink-0" data-id="element-332" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-coral/10 border-2 border-coral/20 p-6 rounded-xl inline-block" data-id="element-333">
            <p className="font-montserrat font-bold text-xl md:text-2xl text-coral" data-id="element-334">
              No es falta de ganas
              <br data-id="element-335" />
              <span className="text-black" data-id="element-336">
                Es falta de claridad y estructura
              </span>
            </p>
          </div>
        </div>
      </Section>

      <Section className="bg-white" data-id="element-337">
        <div className="max-w-3xl mx-auto" data-id="element-338">
          <h2 className="font-montserrat font-black text-3xl md:text-5xl uppercase leading-tight text-center mb-12" data-id="element-339">
            Si esto te pasa, este programa es para vos
          </h2>

          <div className="space-y-4 mb-12" data-id="element-340">
            {['Querés empezar en redes pero no sabés cómo', 'Tenés ideas sueltas pero no las ejecutás', 'Te cuesta ser constante', 'Te bloqueás frente a cámara', 'Sentís que todos ya están adelante'].map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-gray-50 p-4 md:p-6 rounded-xl border border-gray-100 hover:border-coral/30 transition-colors" data-id="element-341">
                <AlertCircle className="w-8 h-8 text-coral shrink-0" data-id="element-342" />
                <span className="font-opensans text-lg md:text-xl font-semibold text-gray-800" data-id="element-343">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-344">
            <p className="font-montserrat font-black text-2xl md:text-3xl text-black" data-id="element-345">
              No necesitás más información
              <br data-id="element-346" />
              <span className="text-coral" data-id="element-347">Necesitás un sistema claro</span>
            </p>
          </div>
        </div>
      </Section>
    </>;
};